<template>
  <div>
    <WsAuthAppBar></WsAuthAppBar>
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../assets/scss/app.scss";
</style>